import React from 'react';

export type FullScreenOverlayProps = {
  children?: React.ReactNode;
};

export const FullScreenOverlay = ({ children }: FullScreenOverlayProps) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center p-2">
      {children}
    </div>
  );
};
